<template>
  <div class='period' :loading="loading">
    <a-row class="row">
      <a-col :span="12" class="title">
        随访周期配置
      </a-col>
      <a-col :span="12" style="text-align: right">
        <a-button class='button' type='primary' @click='handleEdit'>配置</a-button>
      </a-col>
    </a-row>
    <div class='row' style="margin-top: 10px">
      <a-descriptions :column="1">
        <a-descriptions-item label="是否需要随访">
          <yn v-model="period.period"></yn>
        </a-descriptions-item>
        <template v-if="period.period==='1'">
          <a-descriptions-item label="随访生成方式">
            {{period.createType?period.createType === '1'?'自动':'手动':''}}
          </a-descriptions-item>
          <template v-if="period.createType==='1'">
            <a-descriptions-item label="随访启动设置">
              {{startSetName}} 
              <a-tooltip v-if="this.period.startSet === '2'">
                <template #title>为满足随访启动条件的受试者生成随访周期</template>
                <a-button type="primary" class='button' @click='buildPeriod'>
                  <a-icon type="question-circle" />
                  生成随访任务
                </a-button>
              </a-tooltip>
            </a-descriptions-item>
            <a-descriptions-item label="分组类别" v-if="period.groupSet === '1'">
              {{period.groupTypeName}}
            </a-descriptions-item>
            <a-descriptions-item label="基点名称">
              {{period.baseName}}
            </a-descriptions-item>
          </template>
        </template>
      </a-descriptions>
      <template v-if="period.period==='1'">
        <div style="margin: 8px 0">
          <a-table v-if="period.createType==='1'"
                   :columns='columns1'
                   :dataSource='dataSource1'
                   :loading='loading'
                   :pagination='false'
                   :scroll="{x:'800px',y:'300px'}"

                   rowKey='id'
                   size='small'>
            <span slot="answerUnexpired" slot-scope="text, record, index">
              <yn v-model="text"></yn>
            </span>
            <span slot="answerOverdue" slot-scope="text, record, index">
              <yn v-model="text"></yn>
            </span>
            <span slot="isCopy" slot-scope="text, record, index">
              <yn v-model="text"></yn>
            </span>
            <span slot="editVisitDate" slot-scope="text, record, index">
              <yn v-model="text"></yn>
            </span>

          </a-table>
        </div>
        <a-descriptions :column="1" v-if="period.createType==='1'">
          <a-descriptions-item label="中途手动添加周期">
            <yn v-model="period.halfway"></yn>
          </a-descriptions-item>
        </a-descriptions>
        <a-table v-if="period.createType === '2' || period.halfway==='1'"
                 :columns='columns2'
                 :dataSource='dataSource2'
                 :loading='loading'
                 :pagination='false'
                 :scroll="{y:'300px'}"

                 rowKey='id'
                 size='small'></a-table>
      </template>
    </div>
    <!--随访周期配置-->
    <follow-up-period-model ref='followUpPeriodModel' @ok="loadData"></follow-up-period-model>
    <a-modal
        :title="`生成随访任务`"
        :width="800"
        :visible="baseDateView"
        :confirmLoading="buildPeriodloading"
        @ok="handleBuildPeriodOk"
        @cancel="baseDateView = false">        
        <a-descriptions :column="1">
          <a-descriptions-item label="访视日期">
              <a-date-picker value-format='YYYY-MM-DD' v-model="followPeriodDate" />
          </a-descriptions-item>
          <a-descriptions-item label="受试者">
              <a-tooltip>
                <template #title>满足随访条件且还未生成随访周期的所有受试者</template>
                <a-radio-group v-model="selectedPatient">
                  <a-radio value="1">所有受试者</a-radio>
                </a-radio-group>
              </a-tooltip>
          </a-descriptions-item>
        </a-descriptions>  

        <!-- <a-form :model="formData">
          <a-tabs v-model="activeKey">
            <a-tab-pane key="1" tab="基本属性">
              <tab1 :form="formData"></tab1>
            </a-tab-pane>
            <a-tab-pane key="2" tab="扩展属性">
              <tab2 :form="formData"></tab2>
            </a-tab-pane>
          </a-tabs>
        </a-form> -->

      </a-modal>
  </div>
  
</template>

<script>
  import { getAction } from '@/api/manage'
  import FollowUpPeriodModel from './FollowUpPeriodModel'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import Yn from './component/Yn'
  // import Tab1 from './tab1';
  // import Tab2 from './tab2';
  export default {
    name: 'PeriodList',
    components: { Yn, FollowUpPeriodModel },
    computed: {
      columns1() {
        return [
          {
            title: '排序',
            align: 'center',
            dataIndex: 'sortNum',
            width: 50
          },
          {
            title: '周期名称',
            dataIndex: 'name',
            align: 'center',
            ellipsis: true,
          },
          {
            title: '关联事件',
            dataIndex: 'visitName',
            align: 'center',
            width: 130,
          },
          {
            title: '距基点天数',
            dataIndex: 'basePointDay',
            align: 'center',
            width: 80,
          },
          {
            title: '最大可提前天数',
            dataIndex: 'advanceDay',
            aalign: 'center',
            width: 80,
          },
          {
            title: '最大可延后天数',
            dataIndex: 'delayDay',
            align: 'center',
            width: 80,
          },
          {
            title: '允许未到期作答',
            dataIndex: 'answerUnexpired',
            scopedSlots: { customRender: 'answerUnexpired' },
            align: 'center',
            width: 80,
          },
          {
            title: '允许过期作答',
            dataIndex: 'answerOverdue',
            scopedSlots: { customRender: 'answerOverdue' },
            align: 'center',
            width: 80,
          },
          {
            title: '允许复制编辑',
            dataIndex: 'isCopy',
            scopedSlots: { customRender: 'isCopy' },
            align: 'center',
            width: 60,
          },
          {
            title: '修改访视日期',
            dataIndex: 'editVisitDate',
            align: 'center',   
            scopedSlots: { customRender: 'editVisitDate' },         
            width: 60,
          },
        ]
      },
      columns2() {
        return [
          {
            title: '排序',
            align: 'center',
            dataIndex: 'sortNum',
            width: 80
          },
          {
            title: '预设名称',
            dataIndex: 'name',
            align: 'center',
            ellipsis: true,
            width: 200,
          },
        ]
      },
      startSetName: function(){
        let result;
        if (this.period.startSet === '1') {
            result = '根据基点事件自动随访';
        } else if (this.period.startSet === '2') {
            result = '满足条件随访';
        }
        return result
      },
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        period:{
          itemList:[]
        },
        dataSource1:[],
        dataSource2:[],
        loading:false,
        baseDateView: false,
        selectedPatient: '1',
        followPeriodDate:null,
        buildPeriodloading: false,
        // formData: {},
        // activeKey: '1',
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.loading = true
        getAction('/project/projectPeriod/getPeriod',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.period = res.result[0]
            const dataSource1 = []
            const dataSource2 = []
            this.period.itemList.forEach(item=>{
              if(item.halfway ==='0'){
                item.answerUnexpiredBl = item.answerUnexpired==='1'
                item.answerOverdueBl = item.answerOverdue==='1'
                item.editVisitDate =  (item.commonFlag & 1)+''
                console.log("item.editVisitDate:"+item.editVisitDate)
                dataSource1.push(item)
              }
              else if(item.halfway ==='1'){
                dataSource2.push(item)
              }
            })
            this.dataSource1 = dataSource1
            this.dataSource2 = dataSource2
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleEdit(){
        if(!this.period.id){
          return this.$message.warning('请求异常，请稍等或者刷新页面再试')
        }
        this.$refs["followUpPeriodModel"].edit(this.period)
      },
      buildPeriod(){
        this.baseDateView = true;
      },
      handleBuildPeriodOk(){
        // console.log(this.formData)
        if(!this.followPeriodDate){
          return this.$message.warning('请选择访视日期')
        }
        this.buildPeriodloading = true
        
        getAction('/patient/patient/build/period',{projectId:this.projectId,visitDate:this.followPeriodDate}).then(res=>{
          if(res.success){
            this.$message.warning('生成随访任务完成')
            this.baseDateView = false
          }
        }).finally(()=>{
          this.buildPeriodloading = false
        })
      },
    },
  }
</script>

<style scoped>

</style>